import { event } from "./event";
import { kvStorage } from "./kv_storage";

export const akjs = {
  kvStorage,
  event,
};
